<template>
  <div class="ctpx-size-modal ctpx-product-modal">
    <div class="ctpx-modal-close" @click="$emit('close')">X</div>
    <div class="ctpx-modal-content">
      <div v-if="productTitle.includes('Women')">
        <div v-if="tabs.length > 0" class="ctpx-tab-sec">
          <section class="ctpx-tab-nav">
            <div class="container-fluid">
              <div class="row">
                <div class="col">
                  <ul class="tab-nav">
                    <li
                      v-for="(tab, index) in filteredTabs(womensTabs)"
                      :key="index"
                      @click="selectTab(index)"
                      class="tab-nav-link"
                      :class="{ active: index == selectedTabIndex }"
                    >
                      <span>{{ tab.title }}</span>
                    </li>
                  </ul>
                </div>
                <!-- .col -->
              </div>
              <!-- .row -->
            </div>
            <!-- .container -->
          </section>
          <!-- .ctpx-tab-nav -->
          <!-- ========== Section ctpx-tab-sec ========== -->
          <Tab
            v-for="(tab, index) in filteredTabs(womensTabs)"
            :tab="tab"
            class="ctpx-tab"
            :key="tab.title"
            :isActive="index == selectedTabIndex"
          ></Tab>
        </div>
        <!-- .ctpx-tab-sec -->
      </div>
      <div v-if="productTitle.includes('Men')">
        <div v-if="tabs.length > 0" class="ctpx-tab-sec">
          <section class="ctpx-tab-nav">
            <div class="container-fluid">
              <div class="row">
                <div class="col">
                  <ul class="tab-nav">
                    <li
                      v-for="(tab, index) in filteredTabs(mensTabs)"
                      :key="index"
                      @click="selectTab(index)"
                      class="tab-nav-link"
                      :class="{ active: index == selectedTabIndex }"
                    >
                      <span>{{ tab.title }}</span>
                    </li>
                  </ul>
                </div>
                <!-- .col -->
              </div>
              <!-- .row -->
            </div>
            <!-- .container -->
          </section>
          <!-- .ctpx-tab-nav -->
          <!-- ========== Section ctpx-tab-sec ========== -->
          <Tab
            v-for="(tab, index) in filteredTabs(mensTabs)"
            :tab="tab"
            class="ctpx-tab"
            ::key="index"
            :isActive="index == selectedTabIndex"
          ></Tab>
        </div>
      </div>
      <div
        v-if="
          productTitle.includes('Gloves') ||
          productTitle.includes('Glitten') ||
          productTitle.includes('Mitten')
        "
      >
        <div class="small--hide">
          <img
            src="//www.cotopaxi.com/cdn/shop/t/96/assets/gloves-sizing-2024_1400x.jpg"
            class="glove-chart"
          />
        </div>
        <div class="hide small--show">
          <img
            src="//www.cotopaxi.com/cdn/shop/t/96/assets/gloves-sizing-mobile_800x.jpg"
            class="glove-chart"
          />
        </div>
      </div>
      <div v-if="productTitle.includes('Sock')">
        <div v-if="tabs.length > 0" class="ctpx-tab-sec">
          <section class="ctpx-tab-nav">
            <div class="container-fluid">
              <div class="row">
                <div class="col">
                  <ul class="tab-nav">
                    <li
                      v-for="(tab, index) in filteredTabs(sockTabs)"
                      :key="index"
                      @click="selectTab(index)"
                      class="tab-nav-link"
                      :class="{ active: index == selectedTabIndex }"
                    >
                      <span>{{ tab.title }}</span>
                    </li>
                  </ul>
                </div>
                <!-- .col -->
              </div>
              <!-- .row -->
            </div>
            <!-- .container -->
          </section>
          <!-- .ctpx-tab-nav -->
          <!-- ========== Section ctpx-tab-sec ========== -->
          <Tab
            v-for="(tab, index) in filteredTabs(sockTabs)"
            :tab="tab"
            class="ctpx-tab"
            ::key="index"
            :isActive="index == selectedTabIndex"
          ></Tab>
        </div>
      </div>
      <div v-if="productTitle.includes('Kids')">
        <div v-if="tabs.length > 0" class="ctpx-tab-sec">
          <section class="ctpx-tab-nav">
            <div class="container-fluid">
              <div class="row">
                <div class="col">
                  <ul class="tab-nav">
                    <li
                      v-for="(tab, index) in filteredTabs(kidsTabs)"
                      :key="index"
                      @click="selectTab(index)"
                      class="tab-nav-link"
                      :class="{ active: index == selectedTabIndex }"
                    >
                      <span>{{ tab.title }}</span>
                    </li>
                  </ul>
                </div>
                <!-- .col -->
              </div>
              <!-- .row -->
            </div>
            <!-- .container -->
          </section>
          <!-- .ctpx-tab-nav -->
          <!-- ========== Section ctpx-tab-sec ========== -->
          <Tab
            v-for="(tab, index) in filteredTabs(kidsTabs)"
            :tab="tab"
            class="ctpx-tab"
            ::key="index"
            :isActive="index == selectedTabIndex"
          ></Tab>
        </div>
      </div>
      <div v-if="productTitle.includes('Renovo')">
        <div v-if="tabs.length > 0" class="ctpx-tab-sec">
          <section class="ctpx-tab-nav">
            <div class="container-fluid">
              <div class="row">
                <div class="col">
                  <ul class="tab-nav">
                    <li
                      v-for="(tab, index) in filteredTabs(renovoTabs)"
                      :key="index"
                      @click="selectTab(index)"
                      class="tab-nav-link"
                      :class="{ active: index == selectedTabIndex }"
                    >
                      <span>{{ tab.title }}</span>
                    </li>
                  </ul>
                </div>
                <!-- .col -->
              </div>
              <!-- .row -->
            </div>
            <!-- .container -->
          </section>
          <!-- .ctpx-tab-nav -->
          <!-- ========== Section ctpx-tab-sec ========== -->
          <Tab
            v-for="(tab, index) in filteredTabs(renovoTabs)"
            :tab="tab"
            class="ctpx-tab"
            ::key="index"
            :isActive="index == selectedTabIndex"
          ></Tab>
        </div>
      </div>
    </div>
  </div>
  <!--.size guide modal-->
  <div class="ctpx-modal-backdrop" @click="$emit('close')"></div>
</template>
<script src="./ctrl-pdp-sizechart.js"></script>
